import { Component } from '@angular/core';

@Component({
  selector: 'app-test-view',
  templateUrl: './test-view.component.html'
})
export class TestViewComponent {

}
